import * as React from 'react';
import Button from '@mui/material/Button';
import ListSubheader from '@mui/material/ListSubheader';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';

const StyledListHeader = styled(ListSubheader)(({ theme }) => ({
  ...theme.typography.overline,
  fontWeight: theme.typography.fontWeightBold,
  lineHeight: '36px',
  color: theme.palette.text.secondary,
  backgroundColor: theme.palette.background.paper,
}));

export type DropDownMenuItem = {
  value: string;
  label: string;
  category?: string;
};

interface DropDownMenuProps {
  label: string;
  items: DropDownMenuItem[];
  onClick: (value: string) => void;
  disabled?: boolean;
}

function DropDownMenu({ label, items, onClick, disabled = false }: DropDownMenuProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (value: string) => {
    onClick(value);
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="basic-button"
        variant="contained"
        disabled={disabled}
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleButtonClick}
      >
        {label}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {items.map((item, index) => {
          const showCategoryHeader =
            item.category != null &&
            (index === 0 || items[index - 1].category !== item.category);

          return (
            <React.Fragment key={item.value}>
              {showCategoryHeader && (
                <StyledListHeader disableSticky>
                  {item.category}
                </StyledListHeader>
              )}
              <MenuItem onClick={() => handleMenuItemClick(item.value)}>
                {item.label}
              </MenuItem>
            </React.Fragment>
          );
        })}
      </Menu>
    </div>
  );
}

export default React.forwardRef(DropDownMenu);
